import PropTypes from 'prop-types'
import { memo } from 'react'

import {
  StatusCell,
  StatusDotSuccess,
  StatusDotWarning,
  StatusDotDanger,
  StatusDotAccent,
  StatusDotNeutral,
} from './styled-components'
import { NoContractPill } from './table/styled-components'

const STATUS_DOT_BY_VARIANT = {
  success: StatusDotSuccess,
  warning: StatusDotWarning,
  danger: StatusDotDanger,
  accent: StatusDotAccent,
  neutral: StatusDotNeutral,
}

const StatusIndicator = ({ variant = 'neutral', text, hasContract, noContractText }) => {
  if (! hasContract) {
    return <NoContractPill>{noContractText}</NoContractPill>
  }
  const Dot = STATUS_DOT_BY_VARIANT[variant] || StatusDotNeutral

  return (
    <StatusCell>
      <Dot />
      {text}
    </StatusCell>
  )
}

StatusIndicator.propTypes = {
  variant: PropTypes.oneOf([
    'success',
    'warning',
    'danger',
    'accent',
    'neutral',
  ]),
  text: PropTypes.string.isRequired,
  hasContract: PropTypes.bool.isRequired,
  noContractText: PropTypes.string.isRequired,
}

export default memo(StatusIndicator)
